import {
  NoDataComponent,
  PageWrapper,
  SimpleTableLoadingSkeleton,
  STATUSPAGE,
  SUBMIT_BUTTON,
  TableVirtualized,
} from '@repo/ui';
import { GeneralFilters } from 'presentation/app/components/general-filters';
import { Card, Spinner } from 'reactstrap';

import { makeAppRegisteredStudentsPerGroupColumns } from '../../../common/columns/students/app-registered-students-per-group-columns';
import { useAppRegisteredStudentsPerGroup } from '../../../hooks/useAppRegisteredStudentsPerGroup';

export const AppRegisteredStudentsPerGroup = () => {
  // Hooks
  const {
    validation,
    tableLoading,
    hasFetchedData,
    buttonsLoading,
    appRegisteredStudentsPerGroupListData,
    selectedSubmitBtnRef,
    getLegends,
  } = useAppRegisteredStudentsPerGroup();

  const formattedData = appRegisteredStudentsPerGroupListData.map(
    (register, idx) => ({ id: idx, ...register }),
  );

  return (
    <PageWrapper
      title={`${getLegends('ESTUDANTE', true)} Cadastrados no App por ${getLegends('GRUPO', false)}`}
    >
      <h4 className="mb-4">
        {getLegends('ESTUDANTE', true)} Cadastrados no App por{' '}
        {getLegends('GRUPO', false)}
      </h4>

      <Card>
        <GeneralFilters
          validation={validation}
          additionalGeneralInputs={[
            {
              type: 'date',
              id: 'starts',
              label: 'Data inicial:',
              sizes: {
                xs: 6,
                md: 4,
                xl: 3,
                xxl: 2,
              },
              onChange: (e) => validation.handleChange(e),
              isVisible: true,
            },
            {
              type: 'date',
              id: 'ends',
              label: 'Data final:',
              sizes: {
                xs: 6,
                md: 4,
                xl: 3,
                xxl: 2,
              },
              onChange: (e) => validation.handleChange(e),
              isVisible: true,
            },
          ]}
          buttonsChildren={
            <div className="w-100 d-flex justify-content-end gap-2">
              <button
                id="search-button-json"
                type="submit"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.JSON;
                }}
                className="btn btn-primary waves-effect waves-light"
                disabled={
                  Boolean(buttonsLoading) &&
                  selectedSubmitBtnRef.current === SUBMIT_BUTTON.JSON
                }
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.JSON &&
                Boolean(buttonsLoading) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar
                    <i className="ri-computer-line mx-2"></i>
                  </>
                )}
              </button>
              <button
                type="submit"
                id="export-pdf"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.PDF;
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={
                  Boolean(buttonsLoading) &&
                  selectedSubmitBtnRef.current === SUBMIT_BUTTON.PDF
                }
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.PDF &&
                Boolean(buttonsLoading) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar em PDF
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </button>
              <button
                type="submit"
                id="export-excel"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.EXCEL;
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={
                  Boolean(buttonsLoading) &&
                  selectedSubmitBtnRef.current === SUBMIT_BUTTON.EXCEL
                }
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.EXCEL &&
                Boolean(buttonsLoading) ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ri-file-excel-2-line mx-2"></i>
                  </>
                )}
              </button>
            </div>
          }
        />
        {appRegisteredStudentsPerGroupListData?.length === 0 &&
          hasFetchedData &&
          tableLoading === STATUSPAGE.DONE && (
            <div className="p-4">
              <NoDataComponent />
            </div>
          )}

        {tableLoading === STATUSPAGE.LOADING && <SimpleTableLoadingSkeleton />}

        {tableLoading === STATUSPAGE.DONE &&
          appRegisteredStudentsPerGroupListData?.length > 0 && (
            <TableVirtualized
              columns={makeAppRegisteredStudentsPerGroupColumns()}
              data={formattedData}
            />
          )}
      </Card>
    </PageWrapper>
  );
};
